import MenuView from "../../components/MenuView";
import Cards from "../../components/cards";
import {
  Backdrop,
  Box,
  CircularProgress,
  Grid,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  Select,
  InputAdornment,
  MenuItem,
} from "@mui/material";
import useApi from "../../hooks/useApi";
import { useEffect, useState } from "react";
import useSnack from "../../hooks/useSnack";
import SnackAlert from "../../components/SnackAlert";
import SearchIcon from "@mui/icons-material/Search";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import "dayjs/locale/es"; // Para tener el calendario en español
import dayjs from "dayjs";

export default function View() {
  const { loadApi } = useApi();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [searchType, setSearchType] = useState("productos");
  const { showSnack, msgSB, openSB, typeSB } = useSnack();

  const getData = async () => {
    setLoading(true);
    const formattedDate = selectedDate ? selectedDate.format("YYYY-MM-DD") : "";
    console.log(formattedDate, "selectedDate");
    loadApi(`admin/orders?fecha=${formattedDate}`, true, "get")
      .then((response) => {
        setData(response.data || []);
      })
      .catch((error) => {
        showSnack(error.message, "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getData();
  }, [selectedDate]);

  const getProducts = async (name) => {
    loadApi(`admin/filter/orderItems?name=${name}`, true, "get")
      .then((response) => {
        const transformedData = response.data.map((item) => item.Order);
        const uniqueOrders = Array.from(
          new Map(transformedData.map((order) => [order.id, order])).values()
        );
        setData(uniqueOrders || []);
      })
      .catch((error) => {
        showSnack(error.message, "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getUsers = async (name) => {
    loadApi(`admin/filter/shippingInfo?client=${name}`, true, "get")
      .then((response) => {
        setData(response.data || []);
      })
      .catch((error) => {
        showSnack(error.message, "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getOrder = async (id) => {
    loadApi(`admin/filter/orderNumber?orderNumber=${id}`, true, "get")
      .then((response) => {
        setData(response.data || []);
      })
      .catch((error) => {
        showSnack(error.message, "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (searchTerm) {
      setLoading(true);
      const delayDebounce = setTimeout(() => {
        if (searchType === "clientes") {
          getUsers(searchTerm);
        } else if (searchType === "productos") {
          getProducts(searchTerm);
        } else if (searchType === "orden") {
          getOrder(searchTerm);
        }
      }, 900);

      return () => clearTimeout(delayDebounce);
    } else {
      getData();
    }
  }, [searchTerm, searchType]);

  const filteredData = data;

  const handlePriorityChange = (orderId, newPriorityState) => {
    setData(
      data.map((order) =>
        order.id === orderId ? { ...order, priority: newPriorityState } : order
      )
    );
    getData();
  };

  return (
    <>
      <MenuView>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: { xs: "100vh", md: "96vh" },
            padding: 2,
          }}
        >
          <Grid
            container
            spacing={2}
            sx={{ width: "100%", mb: 2 }}
            alignItems="center"
          >
            {/* Título */}
            <Grid item xs={12} md={3}>
              <Typography variant="h4">Pedidos</Typography>
            </Grid>

            {/* Controles de búsqueda */}
            <Grid item xs={12} md={9}>
              <Grid container spacing={2}>
                {/* Selector de fecha */}
                <Grid item xs={12} sm={4} md={3}>
                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    adapterLocale="es"
                  >
                    <DatePicker
                      label="Fecha"
                      value={selectedDate}
                      onChange={(newDate) => {
                        setSelectedDate(newDate);
                        setSearchTerm("");
                      }}
                      format="DD/MM/YYYY"
                      slotProps={{
                        textField: {
                          size: "small",
                          fullWidth: true,
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Grid>

                {/* Selector de tipo de búsqueda */}
                <Grid item xs={12} sm={3} md={3}>
                  <Select
                    value={searchType}
                    onChange={(e) => setSearchType(e.target.value)}
                    size="small"
                    fullWidth
                    MenuProps={{
                      disableScrollLock: true,
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                      },
                    }}
                    sx={{
                      color: "black",
                      ".css-i6gpf3-MuiSvgIcon-root-MuiSelect-icon": {
                        color: "black",
                      },
                    }}
                  >
                    <MenuItem value="productos">Productos</MenuItem>
                    <MenuItem value="clientes">Clientes</MenuItem>
                    <MenuItem value="orden">No. Orden</MenuItem>
                  </Select>
                </Grid>

                {/* Campo de búsqueda */}
                <Grid item xs={12} sm={5} md={6}>
                  <TextField
                    label="Buscar"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    size="small"
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Box sx={{ flex: 1, overflowY: "auto" }}>
            {filteredData.length === 0 ? (
              <Typography variant="h4" align="center">
                No hay pedidos disponibles.
              </Typography>
            ) : (
              <Grid container spacing={2}>
                {filteredData?.map((order) => (
                  <Grid key={order.id} item xs={12} sm={6} md={4}>
                    <Cards
                      order={order}
                      onPriorityChange={handlePriorityChange}
                    />
                  </Grid>
                ))}
              </Grid>
            )}
          </Box>
        </Box>

        <Backdrop
          sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />
      </MenuView>
    </>
  );
}
